import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconEmail16 = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 16 16"
    data-fill-none
  >
    <path
      d="M2.18675 3C1.87201 3 1.57015 3.1317 1.34759 3.36612C1.12503 3.60054 1 3.91848 1 4.25V11.75C1 12.0815 1.12503 12.3995 1.34759 12.6339C1.57015 12.8683 1.87201 13 2.18675 13H2.50599L12 3H2.18675Z"
      fill="white"
    />
    <path
      d="M13.7826 3H2.21739C1.89452 3 1.58487 3.1317 1.35657 3.36612C1.12826 3.60054 1 3.91848 1 4.25V11.75C1 12.0815 1.12826 12.3995 1.35657 12.6339C1.58487 12.8683 1.89452 13 2.21739 13H13.7826C14.1055 13 14.4151 12.8683 14.6434 12.6339C14.8717 12.3995 15 12.0815 15 11.75V4.25C15 3.91848 14.8717 3.60054 14.6434 3.36612C14.4151 3.1317 14.1055 3 13.7826 3Z"
      fill="white"
      stroke="#1E1E1E"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 3.5L8 9L1.5 3.5"
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
IconEmail16.displayName = 'IconEmail16';
